import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-why',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './why.html',
  styleUrl: './why.css',
})
export class Why {
  @ViewChild('demoVideo') demoVideo!: ElementRef<HTMLVideoElement>;

  isPlaying = false;
  progress = 0;

  togglePlay(): void {
    const video = this.demoVideo.nativeElement;
    if (video.paused || video.ended) {
      video.play();
    } else {
      video.pause();
    }
  }

  onTimeUpdate(): void {
    const video = this.demoVideo.nativeElement;
    this.progress = video.duration ? (video.currentTime / video.duration) * 100 : 0;
  }

  seek(event: MouseEvent): void {
    const track = event.currentTarget as HTMLElement;
    const rect = track.getBoundingClientRect();
    const ratio = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
    const video = this.demoVideo.nativeElement;
    if (video.duration) {
      video.currentTime = ratio * video.duration;
    }
  }
}